import {Note} from 'swayok-react-mdb-ui-kit/components/Typography/Note'
import {trans} from '../../../../helpers'

// Выводит предупреждение о правильном поведении в чатах.
export function ChatBehaviorWarning() {

    return (
        <Note color="warning">
            {trans().cabinet.chats.behavior_warning}
        </Note>
    )
}
